import SharedAccountsLayout from "@components/core/SharedAccountsLayout";
import FaqCategory from "./FaqCategory";

function HelpCenter({ faqArticles }) {
  function displayFaqCategories() {
    return faqArticles.map((faqCategory) => (
      <FaqCategory
        key={faqCategory.id}
        faqCategory={faqCategory}
      />
    ));
  }

  return (
    <div>
      <SharedAccountsLayout title="faq" />
      <div className="container help-container py-4 my-2 py-md-7 my-md-3">
        <div className="d-flex flex-column gap-6">
          {displayFaqCategories()}
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;
